import React from 'react';
import * as Sentry from '@sentry/react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.REACT_APP_SENTRY_ENABLED === 'true') {
      Sentry.captureException(error, {
        contexts: {
          react: {
            componentStack: errorInfo.componentStack,
          },
        },
        tags: {
          errorType: 'react_error_boundary',
          boundaryName: this.props.name || 'root',
        },
      });
    }

    if (process.env.NODE_ENV === 'development') {
      console.error(
        `Error caught by boundary (${this.props.name || 'root'}):`,
        error,
        errorInfo,
      );
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    if (typeof this.props.onReset === 'function') {
      this.props.onReset();
    } else {
      window.location.reload();
    }
  };

  render() {
    if (this.state.hasError) {
      if (typeof this.props.fallback === 'function') {
        return this.props.fallback({
          error: this.state.error,
          reset: this.handleReset,
        });
      }
      return (
        <div
          style={{
            padding: '20px',
            textAlign: 'center',
            maxWidth: '600px',
            margin: '50px auto',
          }}
          role="alert"
        >
          <h2>Something went wrong</h2>
          <p>
            {this.props.message ||
              "We're sorry, but something unexpected happened. Please try refreshing the page."}
          </p>
          <button
            onClick={this.handleReset}
            style={{
              padding: '10px 20px',
              marginTop: '20px',
              cursor: 'pointer',
              fontSize: '16px',
            }}
          >
            {this.props.resetLabel || 'Reload Page'}
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
